import ErrorUtil from './ErrorUtil';

export default class RichMap<K extends string | number | symbol, V> {
  private readonly recordMap: Map<K, V>;

  public constructor(record: Record<K, V>) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.recordMap = new Map<K, V>(Object.entries(record) as any);
  }

  /** Get the value or a default value if none */
  public getOrDefault(key: K, defaultVal: V): V {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (this.recordMap.has(key)) ? this.recordMap.get(key)! : defaultVal;
  }

  /** Get the value or the value of a default key */
  public getOrDefaultKey(key: K, defaultKey: K): V {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (this.recordMap.has(key)) ? this.recordMap.get(key)! : this.recordMap.get(defaultKey)!;
  }

  /** Get the value or throw if the map doesn't have it */
  public getOrThrow(key: K): V {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (!this.recordMap.has(key)) {
      throw ErrorUtil.internalError({ msg: `Key not set in map: ${String(key)}` });
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.recordMap.get(key)!;
  }

  /** Get the value or a default value if none */
  public getOrNull(key: string): V | null {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (this.recordMap.has(key as K)) ? this.recordMap.get(key as K)! : null;
  }

  /** return true if this has k and is equal to val */
  public isValEqual(key: K, val: V) {
    return this.recordMap.get(key) === val;
  }
}
